import { DatePipe } from "@angular/common";
import { Component, HostListener, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "../../../service/auth/auth.service";
import { CommunityBoard } from "../../../service/board/board";
import { BoardService } from "../../../service/board/board.service";
import { CommonService } from "../../../service/common/common.service";
import { GtmService } from "../../../service/gtm/gtm.service";

@Component({
  selector: 'app-community-item',
  templateUrl: './community-item.component.html',
  styleUrls: ['./community-item.component.scss'],
  providers: [BoardService, DatePipe]
})
export class CommunityItemComponent implements OnInit {
  @Input() board: CommunityBoard;
  opened: boolean = false;
  url: string;

  constructor(private boardService: BoardService,
    private commonService: CommonService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private gtmService: GtmService,
    private datePipe: DatePipe) {
  }

  ngOnInit() {
    this.isMobile = (window.innerWidth < 768);
    this.url = location.href.split('?')[0] + '/';
  }

  isMobile: boolean;
  @HostListener('window:resize', ['$event']) onResize(event) {
    let isMobile = (event.target.innerWidth < 768);
    if (this.isMobile != isMobile) {
      this.isMobile = isMobile;
    }
  }

  onLike() {
    if (this.board.likeByMe) {
      this.boardService.unlike(this.board.id).subscribe(
        result => {
          this.board.likeByMe = false;
          this.board.countOfLikes--;
          this.initLikeList = false;
        }
      );
    } else {
      this.boardService.like(this.board.id).subscribe(
        result => {
          this.initLikeList = false;
          this.board.likeByMe = true;
          this.board.countOfLikes++;
          this.gtmService.likeEvent({
            'title': this.board.title,
            'list': 'Community',
            'date': this.datePipe.transform(this.board.createdDate, 'yyyyMMdd'),
            'author': this.board.author.nick || this.board.author.name
          });
        }
      );
    }
  }

  onReport() {
    if (window.confirm('신고하시겠습니까?')) {
      this.boardService.report(this.board.id).subscribe(
        result => {
          window.alert('신고가 접수되었습니다.');
        }
      );
    }
  }

  initLikeList = false;
  showLikeList = false;
  likeList = []
  onLikeView() {
    if (!this.initLikeList) {
      this.boardService.likelist(this.board.id).subscribe(
        result => {
          this.likeList = result;
          this.initLikeList = true;
          this.showLikeList = result.length ? true : false;
        }
      )
    }

    if (this.likeList.length) this.showLikeList = true;
  }

  showProfile(email: string) {
    this.commonService.addProfileEvent(email);
  }

  isMine(email: string): boolean {
    return this.authService.getEmail() == email;
  }

  onCanUpdate(): boolean {
    return this.board.author.email == this.authService.getEmail() || this.authService.isAdmin();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/community-board/community-item/community-item.component.ts